module.exports = __webpack_public_path__ + "images/patterns/light/GrooveDiagonal.0f1ff1274c1e31f4d3ce.svg";